import { get } from 'lodash'
import moment from 'moment'

/**
 * Returns either ascending or descending value
 * @param {Object} a - antd Table sorter param a
 * @param {Object} b - antd Table sorter param b
 * @param {String} path - object path for compare
 * @param {Function} mapFn - function to map value from path
 * @param {String} order - optional for manual sorting. ascend, descend or undefined
 * @return {any} a value minus b value
 */
const antdTableSorter = (
  a: object,
  b: object,
  path: string,
  mapFn?: (value: unknown) => void,
  order?: 'ascend' | 'descend' | undefined
): number => {
  const customGet = (val, path) => {
    const result = get(val, path)
    return mapFn ? mapFn(result) : result
  }

  const aValue = customGet(a, path)
  const bValue = customGet(b, path)

  if (typeof aValue === 'number' && typeof bValue === 'number') {
    return order === 'descend' ? bValue - aValue : aValue - bValue
  }

  if (typeof aValue === 'string' && typeof bValue === 'string') {
    const aAsDate = moment(aValue, moment.ISO_8601, true).isValid()
    const bAsDate = moment(bValue, moment.ISO_8601, true).isValid()

    if (aAsDate && bAsDate) {
      return order === 'descend'
        ? moment(bValue).diff(moment(aValue))
        : moment(aValue).diff(moment(bValue))
    }

    return order === 'descend'
      ? aValue.toLowerCase().localeCompare(bValue.toLowerCase())
      : bValue.toLowerCase().localeCompare(aValue.toLowerCase())
  }

  return 0
}

export default antdTableSorter
